import IProductSearchResult from '../../../../functions/src/models/ProductSearchResult';

export function getAllProducts(searchResult: IProductSearchResult) {
  return [
    ...searchResult.products.cheap,
    ...searchResult.products.choice,
    ...searchResult.products.crazy,
  ];
}
